import React, { useEffect, useState } from "react";
import { progressService } from "../../../../../../services/progressService.js";

// ✅ ORIGINAL COMPONENT - No changes
const StakeholderCardPreview = ({
  stakeholder,
  stakeholderNumber,
  values,
  kpis,
  interests,
}) => {
  const gradientClasses = {
    1: "from-[#5303BB] to-[#160131]",
    2: "from-[#FF6B35] to-[#F7931E]",
  };

  const gradient = gradientClasses[stakeholderNumber] || gradientClasses[1];

  return (
    <div className="bg-white rounded-2xl shadow-lg overflow-hidden border border-gray-200 min-w-[390px] max-w-[429px]">
      {/* Header */}
      <div className={`bg-gradient-to-r ${gradient} py-4 px-6 text-white text-center relative`} style={{ height: "146px" }}>
        <p className="text-sm md:text-[14px] font-medium font-gotham text-white uppercase tracking-wide mb-3">
          STAKEHOLDER #{String(stakeholderNumber).padStart(2, "0")}
        </p>
        <div className="absolute left-1/2 transform -translate-x-1/2 top-12 w-[140px] h-[140px] 2xl:w-[163.977294921875px] 2xl:h-[163.977294921875px] rounded-full bg-[#F1F1F1] border-[2px] 2xl:border-[2.76px] border-[#E8E8E8] shadow-xl flex items-center justify-center text-8xl">
          {stakeholder?.avatar ? (
            stakeholder.avatar.startsWith("http") ||
            stakeholder.avatar.startsWith("/static") ||
            stakeholder.avatar.startsWith("/media") ? (
              <img
                src={stakeholder.avatar}
                alt={stakeholder.name}
                className="w-32 h-32 object-contain rounded-full"
              />
            ) : (
              <span className="text-7xl">{stakeholder.avatar}</span>
            )
          ) : (
            "🦁"
          )}
        </div>
      </div>

      {/* Body */}
      <div className="pt-16 pb-6 px-6 space-y-6 bg-white ">
        {/* Name and Role */}
        <div className="text-center pb-6 border-b border-[#E3E3E3] mt-3">
          <h3 className="text-xl md:text-[23px] font-medium text-[#1C1C1C] font-gotham mb-1">
            {stakeholder?.name || ""}
          </h3>
          <p className="text-xs md:text-[14px] text-[#1C1C1C] font-gotham font-normal uppercase tracking-wide">
            {stakeholder?.role || ""}
          </p>
        </div>

        {/* Their Core Values */}
        <div>
          <h4 className="text-xs md:text-[12px] font-bold text-[#000000] font-gotham uppercase tracking-wide mb-3 text-center">
            Their Core Values
          </h4>
          <div className="flex flex-wrap justify-center gap-2">
            {values && values.length > 0 ? (
              values.map((value, index) => (
                <span
                  key={index}
                  className="px-3 py-1.5 bg-black text-white text-xs rounded-full font-medium"
                >
                  {value}
                </span>
              ))
            ) : (
              <>
                <div className="w-[91.67637634277344px] h-7 bg-[#CCCCCC] rounded-full animate-pulse"></div>
                <div className="w-[91.67637634277344px] h-7 bg-[#CCCCCC] rounded-full animate-pulse"></div>
                <div className="w-[91.67637634277344px] h-7 bg-[#CCCCCC] rounded-full animate-pulse"></div>
              </>
            )}
          </div>
        </div>

        {/* Things That Get Them Promoted */}
        <div>
          <h4 className="text-xs md:text-[12px] font-bold text-[#000000] font-gotham uppercase tracking-wide mb-2 text-center">
            Things That Get Them Promoted
          </h4>
          <ul className="space-y-1">
            {kpis && kpis.length > 0 ? (
              kpis.map((kpi, index) => (
                <li key={index} className="flex items-start gap-2 text-sm text-[#323232] font-gotham font-normal md:text-[16px]">
                  <span className="text-gray-400 mt-0.5">•</span>
                  <span>{kpi}</span>
                </li>
              ))
            ) : (
              <>
                <li className="flex items-start gap-2">
                  <span className="text-[#D9D9D9] text-4xl">•</span>
                  <div className="flex-1 h-4 mt-2 bg-[#F0F0F0] rounded-[10px] animate-pulse"></div>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[#D9D9D9] text-4xl">•</span>
                  <div className="flex-1 h-4 mt-2 bg-[#F0F0F0] rounded-[10px] animate-pulse"></div>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[#D9D9D9] text-4xl">•</span>
                  <div className="flex-1 h-4 mt-2 bg-[#F0F0F0] rounded-[10px] animate-pulse"></div>
                </li>
              </>
            )}
          </ul>
        </div>

        {/* Likes & Interests */}
        <div>
          <h4 className="text-xs font-bold text-gray-900 uppercase tracking-wide mb-3 text-center">
            Likes & Interests
          </h4>
          <ul className="space-y-2">
            {interests && interests.length > 0 ? (
              interests.map((interest, index) => (
                <li key={index} className="flex items-start gap-2 text-sm text-[#323232] font-gotham font-normal md:text-[16px]">
                  <span className="text-gray-400 mt-0.5">•</span>
                  <span>{interest}</span>
                </li>
              ))
            ) : (
              <>
                <li className="flex items-start gap-2">
                  <span className="text-[#D9D9D9] text-4xl">•</span>
                  <div className="flex-1 h-4 mt-2 bg-[#F0F0F0] rounded-[10px] animate-pulse"></div>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[#D9D9D9] text-4xl">•</span>
                  <div className="flex-1 h-4 mt-2 bg-[#F0F0F0] rounded-[10px] animate-pulse"></div>
                </li>
                <li className="flex items-start gap-2">
                  <span className="text-[#D9D9D9] text-4xl">•</span>
                  <div className="flex-1 h-4 mt-2 bg-[#F0F0F0] rounded-[10px] animate-pulse"></div>
                </li>
              </>
            )}
          </ul>
        </div>
      </div>
    </div>
  );
};

// 🔥 FIXED & CLEAN VERSION — WORKS WITH YOUR BACKEND FORMAT
export const StakeholderCardWithData = ({ userId, stakeholderIndex = 1 }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      if (!userId) return;
      setLoading(true);

      try {
        // ---- 1) Load stakeholder values widget ----
        const valuesRes = await progressService.getUserDataForSection(
          userId,
          "course_career_progression",
          "interpersonal",
          "stakeholder_values_widget"
        );

        const payload = valuesRes?.payload || valuesRes;
        const stakeholderData = payload?.stakeholderData || {};
        const selected = payload?.selectedStakeholders?.[stakeholderIndex - 1];

        if (!selected) return;

        const key = `stakeholder${stakeholderIndex}`;
        const info = stakeholderData[key] || {};

        // ---- 2) Load avatar from Q1 ----
        const q1Res = await progressService.getUserDataForSection(
          userId,
          "course_career_progression",
          "interpersonal",
          "interpersonal_map"
        );

        const q1Items = q1Res?.visibilityMap?.q1?.items || [];
        const q1Match = q1Items.find((x) => x.id === selected.id);

        const avatar =
          q1Match?.animal || q1Match?.image || selected.avatar || "🦁";

        // Final formatted card data
        setData({
          stakeholder: {
            id: selected.id,
            name: selected.name,
            role: selected.role,
            avatar: avatar,
          },
          stakeholderNumber: stakeholderIndex,
          values: info.values || [],
          kpis: info.kpis || [],
          interests: info.interests || [],
        });
      } catch (err) {
        console.log("❌ Load error:", err);
      }

      setLoading(false);
    };

    load();
  }, [userId, stakeholderIndex]);

  if (loading) return <p>Loading...</p>;
  if (!data) return <p>No Stakeholder Found</p>;

  return (
    <StakeholderCardPreview
      stakeholder={data.stakeholder}
      stakeholderNumber={data.stakeholderNumber}
      values={data.values}
      kpis={data.kpis}
      interests={data.interests}
    />
  );
};



// 🔥 NEW: Show ALL stakeholders
export const AllStakeholderCards = ({ userId }) => {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAllData = async () => {
      console.log("🔥 Fetching all stakeholder data...");
      
      if (!userId) {
        setError("Missing userId");
        setLoading(false);
        return;
      }

      try {
        setLoading(true);

        // STEP 1: Fetch Q1 data for avatars
        console.log("🔥 STEP 1: Fetching Q1 stakeholders...");
        const q1Data = await progressService.getUserDataForSection(
          userId,
          "course_career_progression",
          "interpersonal",
          "interpersonal_map"
        );

        const q1Items = q1Data?.visibilityMap?.q1?.items || [];
        console.log("🔍 Q1 Items:", q1Items);

        // Create avatar map
        const avatarMap = {};
        q1Items.forEach(item => {
          if (item.id) {
            avatarMap[item.id] = item.animal || item.image || "🦁";
          }
        });

        // STEP 2: Fetch stakeholder values
        console.log("🔥 STEP 2: Fetching stakeholder values...");
        const valuesData = await progressService.getUserDataForSection(
          userId,
          "course_career_progression",
          "interpersonal",
          "stakeholder_values_widget"
        );

        console.log("📦 Values Data:", valuesData);

        const payload = valuesData?.payload || valuesData;
        const stakeholderData = payload?.stakeholderData || {};
        const selectedStakeholders = payload?.selectedStakeholders || [];

        console.log("📋 Stakeholder Data:", stakeholderData);
        console.log("📋 Selected Stakeholders:", selectedStakeholders);

        const allCards = [];

        // Stakeholder 1
        if (stakeholderData.stakeholder1 && selectedStakeholders[0]) {
          const avatar = avatarMap[selectedStakeholders[0].id] || selectedStakeholders[0].avatar || "🦁";
          allCards.push({
            stakeholder: {
              id: selectedStakeholders[0].id,
              name: stakeholderData.stakeholder1.name,
              role: stakeholderData.stakeholder1.role,
              avatar: avatar,
            },
            stakeholderNumber: 1,
            values: stakeholderData.stakeholder1.values || [],
            kpis: stakeholderData.stakeholder1.kpis || [],
            interests: stakeholderData.stakeholder1.interests || [],
          });
        }

        // Stakeholder 2
        if (stakeholderData.stakeholder2 && selectedStakeholders[1]) {
          const avatar = avatarMap[selectedStakeholders[1].id] || selectedStakeholders[1].avatar || "🦁";
          allCards.push({
            stakeholder: {
              id: selectedStakeholders[1].id,
              name: stakeholderData.stakeholder2.name,
              role: stakeholderData.stakeholder2.role,
              avatar: avatar,
            },
            stakeholderNumber: 2,
            values: stakeholderData.stakeholder2.values || [],
            kpis: stakeholderData.stakeholder2.kpis || [],
            interests: stakeholderData.stakeholder2.interests || [],
          });
        }

        console.log("✅ All Cards:", allCards);
        setCards(allCards);
        setError(null);

      } catch (err) {
        console.error("❌ Error:", err);
        setError(err.message || "Failed to load data");
      } finally {
        setLoading(false);
      }
    };

    fetchAllData();
  }, [userId]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[400px]">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-purple-600 mx-auto mb-4"></div>
          <p className="text-gray-600 font-gotham">Loading stakeholders...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="flex justify-center items-center min-h-[400px]">
        <div className="bg-red-50 border border-red-200 rounded-lg p-6 max-w-md">
          <p className="text-red-800 font-medium font-gotham">{error}</p>
        </div>
      </div>
    );
  }

  if (cards.length === 0) {
    return (
      <div className="flex justify-center items-center min-h-[400px]">
        <div className="bg-gray-50 border border-gray-200 rounded-lg p-6 max-w-md text-center">
          <p className="text-gray-600 font-gotham">No stakeholders found.</p>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full py-8 px-4">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-3xl font-bold text-center mb-8 font-gotham text-[#1C1C1C]">
          Your Stakeholders
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 justify-items-center">
          {cards.map((card, index) => (
            <StakeholderCardPreview
              key={card.stakeholder.id || index}
              stakeholder={card.stakeholder}
              stakeholderNumber={card.stakeholderNumber}
              values={card.values}
              kpis={card.kpis}
              interests={card.interests}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

export default StakeholderCardPreview;